import { fakeImg } from "@/fake_data.js";
export const FACEBOOK = "facebook";
export const LINE = "line";
export const TWITTER = "twitter";

export const toArticleFormat = ({
  imageFiles,
  videoFiles,
  nodeName,
  pageTitle,
  pagePublishUp,
  pageContent,
  ...others
}) => ({
  type: nodeName,
  title: pageTitle,
  date: pagePublishUp,
  content: pageContent,
  image: imageFiles ? imageFiles[0]?.filePath ?? fakeImg : fakeImg,
  video: videoFiles ? videoFiles[0]?.videoPath ?? "" : "",
  ...others,
});

export const shareArticle = (media) => {
  const goalUrl = getSharedUrl(media);
  window.open(goalUrl, "_blank");
};

const getSharedUrl = (media) => {
  const url = window.location.href;

  if (media === FACEBOOK) return `https://www.facebook.com/sharer.php?u=${url}`;
  else if (media === LINE)
    return `https://social-plugins.line.me/lineit/share?url=${url}`;
  else if (media === TWITTER)
    return `https://twitter.com/intent/tweet?url=${url}`;
  else "";
};
